import { createIconComponent } from '../../factory/create-icon-component';
export const HongKongIcon = createIconComponent(
  'HongKongIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33407)">
      <path d="M23 5H1V20H23V5Z" fill="#D80027" />
      <path
        d="M12.7572 10.6736C12.5906 11.3826 12.2944 11.2474 12.1491 11.8656C11.2931 11.6552 10.7659 10.7748 10.9717 9.89924C11.1775 9.02381 12.0383 8.48461 12.8944 8.69506C12.6037 9.93163 12.9063 10.0396 12.7572 10.6736Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.5352 11.199C11.143 11.5802 10.9257 11.8264 11.4558 12.1588C10.9955 12.9264 10.0139 13.1671 9.26336 12.6964C8.51282 12.2257 8.27744 11.2217 8.73772 10.4542C9.7978 11.119 9.99159 10.8581 10.5352 11.199Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3376 13.5219C10.8799 13.0486 11.0418 13.336 11.5147 12.9232C12.0863 13.608 12.0067 14.6371 11.3371 15.2217C10.6674 15.8063 9.66117 15.7249 9.0896 15.0401C10.0354 14.2146 9.8526 13.9454 10.3376 13.5219Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.4366 14.4323C12.1638 13.7586 12.4811 13.6899 12.2435 13.1024C13.057 12.7581 13.9895 13.1534 14.3262 13.9854C14.6629 14.8175 14.2763 15.7711 13.4628 16.1155C12.9872 14.9404 12.6804 15.035 12.4366 14.4323Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.9316 12.6719C13.2208 12.729 13.2549 12.3991 12.6351 12.4488C12.5663 11.5511 13.2221 10.7663 14.0999 10.6958C14.9776 10.6256 15.745 11.2963 15.8138 12.1939C14.5741 12.2933 14.5672 12.621 13.9316 12.6719Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33407">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
